import {
  GET_REAL_TIME_DISCHARGING,
  GET_REAL_TIME_DISCHARGING_ERROR,
  GET_REAL_TIME_DISCHARGING_SUCCESS,
} from './DischargeTime.actions';

const realTimeDischarging = {
  loading: true,
  error: undefined,
  chargeTime: [],
  table: [],
  boxPlot: [],
  chargeMean: [],
};

/**
 * The real time Discharge reducer.
 */
const realTimeDischargeReducer = (
  state = realTimeDischarging,
  { payload, type }
) => {
  switch (type) {
    case GET_REAL_TIME_DISCHARGING: {
      return { ...state, loading: true, error: undefined };
    }
    case GET_REAL_TIME_DISCHARGING_ERROR: {
      return { ...state, loading: false, error: payload.error };
    }
    case GET_REAL_TIME_DISCHARGING_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        chargeTime: payload.chargeTime,
        table: payload.table,
        boxPlot: payload.boxPlot,
        chargeMean: payload.chargeMean,
      };
    }
    default: {
      return state;
    }
  }
};

export default realTimeDischargeReducer;
